import React, { useMemo } from 'react';
import { StanDataRowHeader } from './StanDataRowHeader';
import { StanDataRowGroupProps, StanDataRowProps } from './StanDataRow.types';
import { generateGridTemplate, getMaxActionButtonCount } from './StanDataRow.logic';
import { cn } from '@/lib';

export const StanDataRowGroup = ({
    headerColumns,
    children,
    className,
    maxActionButtonCount: overrideMaxActionButtonCount,
}: StanDataRowGroupProps) => {
    const detectedMaxActionButtonCount = getMaxActionButtonCount(children);

    // Use override if provided, otherwise use detected count
    const maxActionButtonCount = overrideMaxActionButtonCount ?? detectedMaxActionButtonCount;

    // Calculate grid template from header columns
    const gridTemplate = useMemo(() => generateGridTemplate(headerColumns), [headerColumns]);

    return (
        <div className={cn(className)}>
            {headerColumns.length > 0 && (
                <StanDataRowHeader
                    columns={headerColumns}
                    gridTemplate={gridTemplate}
                    actionButtonCount={maxActionButtonCount}
                />
            )}
            {React.Children.map(children, child => {
                if (React.isValidElement<StanDataRowProps>(child)) {
                    // Only pass props to StanDataRow components, not to wrapper divs or other elements
                    if (child.type && typeof child.type !== 'string') {
                        return React.cloneElement(child, {
                            gridTemplate,
                            maxActionButtonCount,
                        });
                    }
                }
                return child;
            })}
        </div>
    );
};

StanDataRowGroup.displayName = 'StanDataRowGroup';
